import { PhysiologicalDataTableColumn } from './enums';

export const PhysiologicalDataTableColumns = [
  PhysiologicalDataTableColumn.DATE,
  PhysiologicalDataTableColumn.SYS,
  PhysiologicalDataTableColumn.DIA,
  PhysiologicalDataTableColumn.HR,
  PhysiologicalDataTableColumn.BP_TYPE,
];
